import { Fieldset, Grid, NumberInput, Space } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import type { UseFormReturnType } from '@mantine/form';
import { IconCalendar } from '@tabler/icons-react';
import { FormBranchSelector } from '../../../components/form/FormBranchSelector';
import { inputIconStyle } from '../../../theme/styling/iconStyling';
import type { UpsertPrescriptionDto } from '../types/PrescriptionDto';

interface UpsertPrescriptionFormProps {
	form: UseFormReturnType<
		UpsertPrescriptionDto,
		(values: UpsertPrescriptionDto) => UpsertPrescriptionDto
	>;
}

function countInputProps(label: string) {
	return {
		label,
		placeholder: 'Insert amount...',
		allowDecimal: false as const,
		allowNegative: false as const,
		thousandSeparator: ',',
	};
}

export function UpsertPrescriptionForm({ form }: UpsertPrescriptionFormProps) {
	return (
		<>
			<Fieldset legend={'Details'}>
				<Grid>
					<Grid.Col span={6}>
						<FormBranchSelector form={form} property={'branchId'} />
					</Grid.Col>
					<Grid.Col span={6}>
						<DateTimePicker
							clearable
							label={'Date'}
							placeholder={'Pick a date...'}
							leftSection={<IconCalendar {...inputIconStyle} />}
							key={form.key('dateTime')}
							{...form.getInputProps('dateTime')}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
			<Space h={20} />
			<Fieldset legend={'Dispensing'}>
				<Grid>
					<Grid.Col span={4}>
						<NumberInput
							{...countInputProps('Forms')}
							key={form.key('forms')}
							{...form.getInputProps('forms')}
						/>
					</Grid.Col>
					<Grid.Col span={4}>
						<NumberInput
							{...countInputProps('Items')}
							key={form.key('items')}
							{...form.getInputProps('items')}
						/>
					</Grid.Col>
					<Grid.Col span={4}>
						<NumberInput
							{...countInputProps('Methadone Patients No')}
							key={form.key('methadone')}
							{...form.getInputProps('methadone')}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							{...countInputProps('Daily Installments')}
							key={form.key('dailyInstallments')}
							{...form.getInputProps('dailyInstallments')}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							{...countInputProps('Weekly Installments')}
							key={form.key('weeklyInstallments')}
							{...form.getInputProps('weeklyInstallments')}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
			<Space h={20} />
			<Fieldset legend={'PFS'}>
				<Grid>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('PFS Forms')}
							key={form.key('pfsForms')}
							{...form.getInputProps('pfsForms')}
						/>
					</Grid.Col>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('PFS Items')}
							key={form.key('pfsItems')}
							{...form.getInputProps('pfsItems')}
						/>
					</Grid.Col>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('PFS Referrals')}
							key={form.key('pgsReferrals')}
							{...form.getInputProps('pgsReferrals')}
						/>
					</Grid.Col>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('PFS Advice')}
							key={form.key('pfsConsultations')}
							{...form.getInputProps('pfsConsultations')}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
			<Space h={20} />
			<Fieldset legend={'Other'}>
				<Grid>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('Serial Rx Items')}
							key={form.key('serialRxItems')}
							{...form.getInputProps('serialRxItems')}
						/>
					</Grid.Col>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('GP10a Forms')}
							key={form.key('gp10aForms')}
							{...form.getInputProps('gp10aForms')}
						/>
					</Grid.Col>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('GP10a Items')}
							key={form.key('gp10aItems')}
							{...form.getInputProps('gp10aItems')}
						/>
					</Grid.Col>
					<Grid.Col span={3}>
						<NumberInput
							{...countInputProps('Other CP4')}
							key={form.key('otherCp4')}
							{...form.getInputProps('otherCp4')}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
